const purchase = {
  code: "공급업체 코드",
  name: "공급업체 이름",
  shortName: "공급업체 약칭",
  country: "국적/지역",
  address: "주소",
  zipCode: "우편번호",
  email: "이메일 주소",
  contact: "담당자",
  phone: "전화번호",
  fax: "팩스",
  mobile: "휴대폰",
  account1: "개설은행1",
  bank1: "계좌번호1",
  swiftCode1: "은행 코드1",
  account2: "개설은행2",
  bank2: "계좌번호2",
  swiftCode2: "은행 코드2",
  creditLevel: "신용 등급",
  creditLine: "신용 한도",
  depositRate: "계약금 비율(%)",
  tradeTerm: "거래 조건",
  payMethod: "결제 방식",
  affiliates: "관계사",
  org: "담당 부서",
  taxRate: "세율（%）",
  taxRate1: "세율",
  billingDays: "결제 기한(일)",
  principal: "위탁자",
  relatedDocuments: "관련 자료(계약/사업자등록증/송장 자료)",
  price: "가격",
  plCode: "공급업체 코드 입력",
  plName: "공급업체 이름 입력",
  plShortName: "공급업체 약칭 입력",
  plAddress: "공급업체 주소 입력",
  plZipCode: "공급업체 우편번호 입력",
  plEmail: "공급업체 이메일 입력",
  plContact: "담당자 입력",
  plPhone: "공급업체 전화번호 입력",
  plFax: "공급업체 팩스 입력",
  plMobile: "공급업체 휴대폰 입력",
  plBank1: "계좌번호1 입력",
  plAccount1: "개설은행1 입력",
  plSwiftCode1: "은행 코드1 입력",
  plBank2: "계좌번호2 입력",
  plAccount2: "개설은행2 입력",
  plSwiftCode2: "은행 코드2 입력",
  plCreditLine: "신용 한도 입력",
  plDepositRate: "계약금 비율 입력",
  plTradeTerms: "거래 조건 선택",
  plPaymentMethod: "결제 방식 선택",
  plAffiliates: "관계사 입력",
  plTaxRate: "세율 입력",
  plBillingDays: "결제 기한 입력",
  plPrincipal: "위탁자 입력",
  wmsApi: "공급업체 API",
  plWmsApi: "공급업체 API 입력",
  customerList: "공급업체 목록",
  addCustomer: "공급업체 추가",
  documents: "관련 자료",
  codeExisted: '공급업체 코드가 이미 존재합니다',
  supplierNotExisted: "공급업체가 존재하지 않습니다",
  stPrice: '세금 포함 단가',
  priceExisted: '이미 해당 상품에 가격이 있습니다',
  product: "상품",
  plPrice: "세금 포함 단가 입력",
  expiredAt: '만료 시간',
  plExpiredAt: '만료 시간 선택',
  priceExpiredAt: '유효 기간',
  days: '공급 주기(일)',
  plDays: '공급 주기 입력',
  mpq: '최소 포장 단위',
  plMpq: '최소 포장 단위 입력',
  remark: '비고',
  plRemark: "비고 입력",
  plRemarkMax: '내용은 {{ length }}자를 초과할 수 없습니다',
  priceIndex: '상품 가격 {{ index }}',
  priceCount: '수량',
  plPriceCountIndex: '계단식 가격 {{ index }}의 수량은 필수 입력 항목입니다',
  plPriceCount: '계단식 수량 입력',
  plPriceItemIndex: '계단식 가격 {{ index }}의 세금 포함 단가는 필수 입력 항목입니다',
  plPriceIndex: '해당 세금 포함 단가 입력',
  plPriceAdd: '계단식 가격 추가',
  purchaseType: '구매 유형',
  plPurchaseType: '구매 유형 선택',
  plSupplier: '공급업체 선택',
  plProduct: '상품과 가격 선택',
  plProductPrice: '상품과 가격 선택, 이름을 입력하면 검색 가능',
  supplier: '공급업체 정보',
  productCount: '상품 수량',
  plProductCount: '상품 수량 입력',
  scheduledOrderTime: '예상 주문 시간',
  plScheduledOrderTime: '예상 주문 시간 선택',
  deliveryDeadline: '요청 납품 시간',
  plDeliveryDeadline: '요청 납품 시간 선택',
  estimateArrivalAt: '예상 도착 시간',
  plEstimateArrivalAt: '예상 도착 시간 선택',
  deliveredQuantity: '누적 납품 완료 수량',
  plDeliveredQuantity: '납품 완료 수량 선택',
  productDesc: '상품 단품 비고',
  plProductDesc: '상품 단품 비고 입력',
  orderDesc: '주문 비고',
  plOrderDesc: '주문 비고 입력',
  productInfo: '상품 정보',
  orderNotExisted: "구매 주문이 존재하지 않습니다",
  purchased: '주문 완료',
  notPurchase: '미주문',
  noPurOrder: '구매 대기',
  orderTime: '주문 시간',
  supplierInfo: '공급업체 정보',
  orderList: '구매 주문 목록',
  addPrice: "상품 가격 추가",
  bySearchPrice: "재고 코드, 재고 이름, 제품 모델로 검색",
  bySearchSupplier: '공급업체 코드, 이름, 약칭, 주소로 검색',
  orderNumber: '주문 번호',
  purNo: '구매 주문 번호',
  orderState: '주문 상태',
  type: '구매 유형',
  count: '구매 수량',
  amount: '세금 제외 총 가격',
  rateAmount: '세금 포함 총 가격',
  priceDetail: "가격 정보",
  printedTip: "이 주문은 이미 인쇄되었습니다",
  printSelectTip: "인쇄할 데이터를 최소 1개 선택하세요",
  orderNum: "주문 번호",
  orderTime1: "주문 일자",
  currency: "결제 통화",
  demandNum: "수요 주문 번호",
  quantity: "수량",
  priceTax: "세금 포함 단가",
  totalPrice: "세금 포함 합계",
  deliveryTime: "납품 일자",
  total: "합계",
  purchase: "구매",
  review: "검토",
  signature: "공급업체 서명",
  createTime: "생성 일자",
  reviewTime: "검토 일자",
  sigTime: "서명 일자",
  notSelect: "선택 불가",
  selectPurError: "동일한 공급업체의 구매 주문을 선택하세요",
  selectCurrencyError: "동일한 결제 통화의 구매 주문을 선택하세요",
  selectPayMethodError: "동일한 결제 방식의 구매 주문을 선택하세요",
  addOrder: "주문 추가",
  searchCode: "재고 코드로 검색",
  supplierPrint: '공급업체',
  currencyPoint: '결제 통화:',
  purchaseList: '구매 주문',
  pageIndex: '{{ index }}페이지 / 총 {{ total }}페이지',
  printReq: '구매 문서 생성',
  printRejectedFiltered: "거부된 주문 필터링됨",
  printRejectedFilteredDesc: "{{rejectedCount}}개의 거부된 주문이 자동으로 필터링되었고, {{validCount}}개의 유효한 주문으로 구매 문서를 생성합니다.",
  printRejectedBlocked: "구매 문서를 생성할 수 없음",
  printRejectedBlockedDesc: "선택한 주문이 모두 거부된 상태입니다. 선택을 조정한 후 다시 시도하세요.",
  downloadFile: '생성된 구매 파일을 다운로드할 수 있습니다',
  successFile: '구매 파일이 성공적으로 생성되었습니다. 로컬 인쇄를 시작합니다~',
  placeOrder: "주문",
  completed: "완료",
  plPlaceOrder: "이 주문이 주문되었습니까?",
  plPlaceOrders: "이 주문들이 주문되었습니까?",
  plOrderOk: "이 주문이 완료되었습니까?",
  plSeSupplier: "공급업체 선택",
  plPlacePrice: "주문 가격 선택",
  search: "검색",
  clearFilters: "필터 초기화",
  materialCode: "자재 코드",
  materialName: "자재 이름",
  materialModel: "자재 모델",
  purCount: "구매 수량",
  supplierTime: "자재 준비 시간",
  addPurOrder: "구매 주문 생성",
  addPurOrderTip: "자동으로 구매 주문 생성",
  roundMethod: "반올림 방법",
  roundNone: "반올림 안 함",
  roundDown: "내림",
  roundUp: "올림",
  roundNearest: "사사오입",
  addPurSuccessTip: "구매 주문 생성 성공",
  addPurSuccessTipDesc: "총 주문: {{all}}, 생성된 구매 주문: {{suc}}",
  purConfirm: "구매 확인",
  conPur: "구매 확인",
  notPur: "구매 안 함",
  purCurrency: "구매 통화",
  curr: "통화",
  exchangeRateL: "환율",
  purPrice: "가격",
  purPrice_1: "구매 가격",
  purPrice_2: "구매 단가",
  all: "합계",
  supplierUserName: '공급업체 계정 이름',
  supplierUser: '공급업체 계정',
  supplierReset: '비밀번호 재설정',
  initPwd: '초기 비밀번호',
  plSupplierUser: '공급업체 계정 입력',
  supplierUserAdd: '공급업체 계정 추가',
  supplierUserSearch: '계정으로 검색',
  resetPwd: '비밀번호가 {{ newPwd }}(으)로 재설정됩니다',
  resetPwdOk: '비밀번호 재설정 성공',
  editPwdError: '비밀번호 변경 실패',
  userList: '공급업체 계정 목록',
  accounts: '공급업체 계정',
  ceil: "소계",
  addNoPurSuccess: "새로운 구매 주문이 생성되지 않았습니다",
  printState: '인쇄 상태',
  unPrt: '미인쇄',
  supplierBatchNo: '공급업체 배치 번호',
  batchDeliveryNote: '일괄 납품서',
  batchCompletedProduction: '일괄 완료',
  batchCompleteSummary: '{{selected}}개 선택됨',
  batchCompleteNoAvailable: '선택한 항목 중 완료 가능한 주문이 없습니다',
  inventoryCode: '재고 코드',
  supplierCode: '공급업체 코드',
  supplierName: '공급업체 이름',
  purchaseQuantity: '구매 수량',
  supplierLot: '공급업체 배치 번호',
  plSupplierLot: '공급업체 배치 번호 입력',
  pleaseSelect: '최소 1개 데이터 선택',
  pleaseSelectDeliveryTime: '납품 시간 선택',
  pleaseInputDeliveryCount: "배송 수량과 lot을 입력하세요",
  leastOneMoreZero: "최소 하나의 배송 수량이 0보다 커야 하며 lot은 필수입니다",
  pleaseInputSupplierLot: '공급업체 배치 번호 입력',
  batchDeliverySuccess: '일괄 납품서 생성 성공',
  plSupplierBatchNo: '공급업체 배치 번호 입력',
  maxDeliveryQty: '납품 가능 수량',
  noDeliveryData: '구매 주문을 계속 생성할 데이터가 없습니다',
  deliveryDate: '납품 시간',
  selectDeliveryDate: '납품 시간 선택',
  prt: '인쇄됨',
  isPrted: '인쇄 여부',
  payMethodPoint: "수납 약정 이름:",
  printCode: '자재 번호',
  printName: '제품명',
  printModel: '규격/모델',
  spec: '규격',
  printUnit: '단위',
  printNum: '수량',
  printSPrice: '세금 포함 단가',
  printPrce: '세금 포함 금액',
  del: '폐기',
  delTips: '폐기 확인',
  delContent: '이 데이터를 폐기하시겠습니까? 폐기 후 데이터는 복구할 수 없습니다!',
  state: '상태',
  acceptType: '수락됨',
  rejectType: '거부됨',
  pend: '대기 중',
  rejectDetail: '반려 상세',
  accept: '수락',
  reject: '거부',
  rejectDate: '반려 시간',
  operationPerson: '작업자',
  rejectInformate: '반려 정보',
  comfi: '구매 주문을 수락하시겠습니까?',
  ok: '확인',
  cancel: '취소',
  rejectComfi: '구매 주문을 거부하시겠습니까?',
  reOrder: '공급업체 재선택',
  operate: '작업',
  priced: "이 상품에는 유효한 견적이 이미 있습니다!",
  priceManage: '견적서 승인',
  selectNumOver: "최대 10개 선택 가능!",
  onOk: '견적서를 승인하시겠습니까?',
  onReject: '견적서를 거부하시겠습니까?',
  payMethodName: '결제 약정',
  helpAcc: '수락 지원',
  sendTimePrint: '납품 일자',
  mobilePrint: '연락처',
  recver: "담당자",
  seq: "일련번호",
  sendNum: "납품 배치 번호",
  outLot: "출고 배치",
  sendAddress: "납품 주소",
  printErr: "인쇄 실패",
  printDeliveryNote: "납품서 인쇄",
  phone1: "연락처",
  orderDetail: "납품서 상세",
  sendInfo: "납품 정보",
  delivery: '납품서',
  deliveryNumber: '납품서 번호',
  deliveryStatus: '완료 상태',
  updatePurchaseOrderStatus: '구매 주문 상태 변경',
  purchaseOrderStatus: '구매 주문 상태',
  deliverable: '납품 가능',
  notDeliverable: '납품 불가능',
  inState: '입고 상태',
  unArrived: '미입고',
  partialIn: '부분 입고',
  allIn: '전체 입고',
  pendingProduction: '생산 대기',
  inProduction: '생산 중',
  finishedProduction: '생산 완료',
  completedProduction: '완료',
  confirmCompletedProduction: '이 주문을 완료하시겠습니까?',
  confirmBatchCompletedProduction: '이 주문들을 일괄 완료하시겠습니까?',
  markAsFinished: '완료로 표시',
  confirmFinish: '이 항목을 완료하시겠습니까?',
  complete: '완료',
  startProduction: '생산 시작',
  markAsFinishedProduction: '생산 완료로 표시',
  confirmFinishProduction: '이 항목을 생산 완료로 표시하시겠습니까?',
  confirmMarkAsInProduction: '생산 중으로 표시하시겠습니까?',
  confirmMarkAsFinished: '완료로 표시하시겠습니까?',
  markAsInProduction: '생산 중으로 표시',
  selectStatus: '상태 선택',
  confirmMarkAsStatus: '<strong>{{status}}</strong>(으)로 표시하시겠습니까?',
  deliveryDatePlaceholder: '최종 납품 일자',
  notInStock: '미입고',
  inStock: '입고됨',
  deliveryOrders: '납품서 생성됨',
  goodName: '자재 이름',
  goodCode: '재고 코드',
  goodModel: '모델',
  preInventory: '사전 입고 주문',
  saveCodes: '바코드 저장',
  clearCodes: '바코드 지우기',
  outOrder: '입출고 주문 생성됨',
  isOut: '출고됨',
  notOut: '미출고',
  hasPurOrder: '구매 주문 생성됨',
  outOrderNumber: '출고 주문 번호',
  goodsExpiredAt: '자재 유효기간',
  plGoodsExpiredAt: '자재 유효기간 입력',
  year: '년',
  helpAccSuc: '해당 공급업체가 견적을 수락하도록 지원했습니다.',
  helpRejSuc: '해당 공급업체가 견적을 거부하도록 지원했습니다.',
  noReq: '공급업체를 다시 선택할 수 없습니다!',
  noReqDesc: '이 구매 주문에는 문의서가 없어 공급업체를 다시 선택할 수 없습니다',
  equotationRequest: '문의서 상태',
  receivingUnit: '수령 단위',
  receivingAddress: '납품 주소',
  deliveryProgress: '납품서 진행률',
  zfed: "폐기됨",
  mainCurPrice: "기준 통화 금액",
  billingDay: "결제 기한:",
  sendAdd: "배송 주소:",
  unRatePrice: "세금 제외 단가",
  nilPur: "생성되지 않음",
  purState: "구매 주문 상태",
  sendAds: "배송 주소",
  sendAdsPl: "배송 주소 선택",
  accer: "수취인",
  rePrt: "재인쇄",
  rePrtCon: "재인쇄하시겠습니까?",
  plRePrt: "재인쇄하세요",
  onlyOneReq: "동일한 수요 주문의 주문만 선택 가능",
  multyDown: "일괄 다운로드",
  downErr: "다운로드 실패",
  leastOne: "최소 1개 데이터 선택",
  inReturn: "반품 완료",
  stocked: "입고 여부",
  selectDateError: "동일한 배송 시간의 주문만 선택 가능",
  spareRate: "예비품률(%)",
  spareRate_1: "예비품률",
  spareRatePl: "예비품률 입력",
  spareCount: "예비품 수량",
  spareCountPl: "예비품 수량 입력",
  cancelReturn: "반품 취소",
  reqPur: "수요 주문/구매 주문",
  pdaPrint: "구매 주문 PDA 인쇄",
  qcNum: "샘플링 수량",
  qcNo: "불량 수량",
  qcOk: "검사 결과",
  qc: "승인",
  pg: "품질 관리",
  cg: "창고 관리자",
  outPrint: "출고 주문 인쇄",
  checkoutOrder: "검수서",
  normalTemplate: "일반 템플릿",
  warehouseTemplate: "창고 템플릿",
  brand: "브랜드",
  plBrand: "브랜드 입력",
  dictCurrency: "통화",
  printSetting: "인쇄 설정",
  otherInfo: "자재 라벨",
  originalBrand: "자재 원본 브랜드명",
  originalCode: "자재 원본 코드",
  mpn: "원본 코드",
  plMpn: "원본 코드 입력",
  manufactureDate: "자재 원본 생산 주기",
  msdLevel: "MSD 등급",
  dcc: "D/C",
  plShelfLife: "유통기한 입력",
  originPlace: "원산지",
  netWeight: "순중량",
  grossWeight: "총중량",
  plOriginalBrand: "자재 원본 브랜드명 입력",
  plOriginalCode: "자재 원본 코드 입력",
  plManufactureDate: "자재 원본 생산 주기 입력",
  plMsdLevel: "MSD 등급 입력",
  plOriginPlace: "원산지 입력",
  plNetWeight: "순중량 입력",
  plGrossWeight: "총중량 입력",
  importSupplierPrice: '공급업체 가격 가져오기',
  downloadPriceTemplate: '가격 템플릿 다운로드',
  importSuccess: '가져오기 성공',
  importSuccessDesc: '{{count}}개 자재의 가격 데이터를 성공적으로 가져왔습니다',
  importCompleted: '가져오기 완료',
  importPartialDesc: '성공 {{success}}개, 실패 {{failed}}개 ({{failedList}})',
  fileParseError: '파일 구문 분석 실패, 파일 형식을 확인하세요',
  templateWarningTitle: '주의',
  templateWarningIntro: '가격 템플릿 작성 규칙을 확인하세요:',
  templateWarning1: '1. 여러 자재를 한 번에 작성할 수 있습니다. 자재 코드의 정확성을 보장하세요;',
  templateWarning2: '2. 각 자재는 여러 행을 작성할 수 있습니다. 첫 번째 행은 기준 가격이며 수량은 작성할 수 없습니다. 두 번째 행 이후는 계단식 가격으로, 재고 코드, 세금 포함 단가 및 수량을 입력하세요;',
  templateWarning3: '3. 결제 통화(대소문자 무관)가 시스템에 존재하는지 확인하세요;',
  templateWarning4: '4. 시작일과 종료일 필드는 8자리 숫자여야 합니다. 예: 20260309 (2026년 3월 9일);',
  templateWarning5: '5. 데이터 오류는 구문 분석 실패 또는 가져오기 오류를 초래할 수 있습니다;',
  templateWarning6: '6. 공급업체 코드 열은 필수입니다;',
  iHaveKnown: '확인했습니다',
  confirmOrder: '주문하시겠습니까?',
  confirmOrderTip: '주문을 확인하시겠습니까?',
  incompleteRecipientInfo: '수령처, 수령 주소, 담당자, 연락처 등 정보가 불완전합니다.',
  pleaseCompleteRecipientInfo: '수령처 정보를 완성하세요',
  recipientInfoDetails: '수령처, 수령 주소, 담당자, 연락처',
  syncToSupplier: '공급업체 상태 동기화',
  priceTemplateFileName: '공급업체 가격 템플릿',
  excelHeaderInventoryCode: '재고 코드',
  excelHeaderUnitPriceIncludingTax: '세금 포함 단가',
  excelHeaderMaterialValidityPeriod: '자재 유효기간(년)',
  excelHeaderSupplyCycle: '공급 주기(일)',
  excelHeaderMinimumPackage: '최소 포장 단위',
  excelHeaderQuantity: '수량',
  excelHeaderSettlementCurrency: '결제 통화',
  excelHeaderBrand: '브랜드',
  excelHeaderMpn: '원본 코드',
  excelHeaderShelfLife: 'D/C',
  supplierPrice: '공급업체 가격',
  supplierHisPrice: '공급업체 과거 가격',
  hisPriceExport: '과거 가격 내보내기',
  allPriceHis: '전체 과거 가격 내보내기',
  generated: "생성됨",
  importInbound: "가져오기로 납품서 생성",
  inboundTemplate: "납품서 가져오기 템플릿",
  sendTime: "납품 일자",
  inboundTemplateTip1: "1. 납품 일자는 8자리 숫자로 입력하세요. 예: 20260311 (2026년 3월 11일)",
  inboundTemplateTip2: "2. 수량에는 해당 구매 주문의 납품 수량을 입력하세요",
  inboundTemplateTip3: "3. 동일한 구매 주문 번호와 동일한 납품 시간의 레코드는 병합되며 수량이 합산됩니다",
  inboundTemplateTip4: "4. 데이터가 규정에 맞지 않으면 구문 분석 실패 또는 가져오기 실패가 발생할 수 있습니다!",
  inboundTemplateTip5: "5. lot 열은 선택 사항이며, 입력하지 않으면 시스템이 자동으로 배치를 생성합니다",
  noData: "구문 분석된 데이터가 없습니다",
  matchErr: "구매 주문 데이터 매칭 실패, 다시 시도하세요!",
  importDone: "가져오기 완료",
  succNum: "성공 개수",
  importErrTip: "다음 구매 주문은 데이터 확인이 필요합니다",
  maxQuantityErr: "다음 구매 주문의 총 납품 수량이 납품 가능 수량을 초과했습니다",
  excelCount: "총 납품 수량",
  purNoErr: "{{index}}행: 구매 주문 번호 검증 오류",
  countErr: "{{index}}행: 납품 수량 오류",
  preTimeErr: "{{index}}행: 납품 시간 오류",
  importErr: "데이터 매칭 실패, 가져온 데이터 없음",
  notPurNo: '다음 구매 주문이 존재하지 않습니다',
  numAdds: '수량 합계',
  rateNumAdds: '세금 포함 금액 합계',
  ratePceAdds: '세금 포함 단가 합계',
  toReturn: "반품 대기",
  returnQty: "반품 수량",
  actualArrivalQty: "실제 도착 수량",
  actualArrivalTime: "실제 도착 시간",
  undeliveredQty: "미납품 수량",
  orderNums: "납품서 수량",
  importSuppOrders: "가져오기로 공급업체 납품서 생성",
  allSendQty: "총 납품 수량",
  sentQty: "기 납품 수량",
  sendQty: "금회 납품 수량",
  remainQTy: "잔여 납품 수량",
  noSendInfo: "납품 정보 없음",
  fileLoss: "가져오기 원본 파일 누락!",
  import: "템플릿 데이터 가져오기",
  matchPur: "구매 주문 매칭",
  done: "완료",
  thdCode: "MES 고객 코드",
  plThdCode: "MES 고객 코드 입력",
  batchSubmit: '일괄 견적',
  batchSubmitSucc: '일괄 견적 성공',
  batchSubmitErr: '일괄 견적 실패',
  needPriceTip: '다음 데이터는 수동으로 가격을 입력해야 합니다',
  batchSubmitTip: '선택한 문의서에 대해 견적을 제출하시겠습니까?',
  actualInboundTime: "실제 입고 시간",
  supplierCodeNeed: "{{index}}행에 공급업체 코드가 존재하지 않아 구문 분석 실패",
  addRule: "구매 주문 거래 조항을 추가하시겠습니까?",
  effectiveAt: "시작일",
  expiredAtEcl: "종료일",
  effectiveAtPl: "시작일 선택",
  expiredAtEclPl: "종료일 선택",
  purOrderPl: "구매 주문 선택",
  notApi: "이 공급업체는 API가 구성되지 않아 주문 전환이 불가능합니다!",
  swapData: "전환 데이터",
  swapDone: "전환 완료",
  notSuppPros: "공급업체 시스템에 이러한 상품이 존재하지 않습니다. 해당 공급업체 시스템에 상품 정보를 추가하세요.",
  notSaleProPrice: "공급업체 시스템에 해당 최종 고객의 고객 가격이 존재하지 않습니다. 해당 공급업체 시스템에 고객 가격을 추가하세요.",
  purchaseTransferSuccess: "구매 주문 전환 완료",
  noRejected: "이 구매 주문은 거부되어 전환할 수 없습니다!",
  swapErr: "전환 실패",
  startSwap: "전환 시작",
  priceComputedTip: "상품 수량 또는 세율이 변경되어 가격을 다시 계산해야 합니다",
  selectPurErrorTip: "동일한 공급업체, 동일한 결제 통화, 동일한 결제 수단의 항목을 선택하세요",
  notResolved: "이 구매 주문은 접수 상태가 아니어서 선택할 수 없습니다",
  printedTipErr: "다음 항목은 이미 인쇄되어 다시 인쇄할 수 없습니다",
  downloadTip: "PDF 생성 완료. 다운로드하시겠습니까?",
  pdfIng: "PDF 생성 중",
  addPurchaseOrder: "구매 주문 추가",
  addItem: "주문 항목 추가",
  item: "주문 항목",
  items: "주문 항목",
  plCurrency: "통화 선택",
  plPayMethod: "결제 수단 선택",
  ladderPrice: "단계 가격",
  ladderPriceCount: "수량",
  productType: "제품 유형",
  brandName: "브랜드명",
  brandModel: "브랜드 모델",
};

export default purchase;
